export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-100 mb-5">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
          联系与投稿
        </h2>
        <p className="text-sm text-foreground-600 leading-relaxed mb-6">
          如果你有漫画汉化、原创投稿或商务合作需求，欢迎通过以下方式联系我们。酷漫屋期待与每一位漫画创作者和爱好者携手，共同打造更丰富的免费漫画阅读平台。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="mailto:contact@kumanwu.com"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-mail-line"></i>发送邮件
          </a>
          <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-background-300 text-foreground-600 text-sm whitespace-nowrap">
            <i className="ri-wechat-line text-accent-500"></i>微信公众号：酷漫屋
          </span>
        </div>
      </div>
    </section>
  );
}